(function ($) {
    class ColorSlider {
        constructor() {
            this.x0 = 0;
            this.width = 0;
            this.slider = null;
            this.visibleWidth = 30;
            this.imgTop = $("#img1 img");
            this.line = $(".line");
            this.imgTopMask = $("#img1");
            this.imgBottom = $("#img2");
            this.pointer = $(".pointer");
            this.box = $(".mediaBoxNew__images");
            this.pointerContainer = $(".pointer-container");
            this.init();
        }

        initColorSlider() {

            this.onResize();
            $(window).on('resize', this.onResize());
            this.pointerContainer.off();

            if (this.is_touch_device()) {
                this.pointerContainer.on("touchstart", onStartMove.bind(this));
                this.pointerContainer.on("touchend", onEndMove.bind(this));
                this.box.on("mouseleave", this.onEndMoveMouse.bind(this));

            } else {
                this.pointerContainer.on("mousedown", this.onStartMoveMouse.bind(this));
                this.pointerContainer.on("mouseup", this.onEndMoveMouse.bind(this));
                this.box.on("mouseleave", this.onEndMoveMouse.bind(this));
                this.box.on("mouseout", this.onEndMoveMouse.bind(this));
            }
        }
        onMoveMouse(e) {
            this.visibleWidth -= (this.x0 - e.pageX) / this.width * 100;
            this.visibleWidth = this.visibleWidth < 0 ? 0 : this.visibleWidth;
            this.visibleWidth = this.visibleWidth > 100 ? 100 : this.visibleWidth;
            this.x0 = e.pageX;
            this.onResize();
        }
        onStartMoveMouse(e) {
            this.box.on("mousemove", this.onMoveMouse.bind(this));
            this.x0 = e.pageX;
        }
        onEndMoveMouse(e) {
            this.box.off("mousemove");
            this.visibleWidth = this.visibleWidth < 0 ? 0 : this.visibleWidth;
            this.visibleWidth = this.visibleWidth > 100 ? 100 : this.visibleWidth;
            this.onResize();
        }
        onResize() {
            this.width = this.imgBottom.width();
            this.imgTop.width(this.width);
            this.imgTop.css('min-width', this.width + "px");
            this.imgTop.height(this.imgBottom.height());
            this.line.height(this.imgBottom.height());
            this.imgTopMask.width(this.visibleWidth + "%");
            this.imgTopMask.height(this.imgBottom.height());
            this.pointer.css("top", (this.imgBottom.height() / 2 - 40) + "px");
            this.pointerContainer.css("left", (this.imgTopMask.width() - 5) + "px");
            if (this.imgBottom.height() < 1) {
                setTimeout(this.onResize.bind(this), 300);
            }
        }

        init() {
            this.initColorSlider();
        }
        is_touch_device() {

            var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

            var mq = function (query) {
                return window.matchMedia(query).matches;
            }

            if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
                return true;
            }

            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
            return mq(query);
        }

    }

    if (window._mgw_is_colorslider) {
        new ColorSlider();
    }

})(jQuery)